import basicmodal from "../basicmodal";
import toggleHidden from "../../helpers/toggle-hidden";

const bankerSearchNoFilter = (createModal) => {
  const listEl = document.getElementById("bankergrid");
  const templateEl = document.getElementById("bankercardtemplate");
  const paginationEl = document.getElementById("bankerspagination");
  const nextEl = document.getElementById("bankersnext");

  const hiddenFilterEls = document.querySelectorAll(
    "input.bankergrid-hidden-filter"
  );
  if (listEl) {
    listEl.setAttribute("data-js", "bankergrid");
  }

  const gridContainerEl = document.querySelector("[data-js=bankergrid]");
  if (gridContainerEl) {
    const getFilterSettings = (pageIndex) => {
      const filter_data = [`page=${pageIndex}`];

      for (let w = hiddenFilterEls.length - 1; w >= 0; w -= 1) {
        const name = hiddenFilterEls[w].getAttribute("name");
        filter_data.push(`${name}=${hiddenFilterEls[w].value}`);
      }

      return filter_data.join("&");
    };

    const outputItems = (data) => {
      const totalPages = Number(data.pagination.totalPages);
      const currentPage = Number(data.pagination.currentPage) + 1;
      nextEl.value = data.pagination.nextPage;

      toggleHidden(paginationEl, data.pagination !== false);
      toggleHidden(nextEl, data.pagination.nextPage !== false);

      if (currentPage === totalPages || currentPage > totalPages) {
        toggleHidden(paginationEl, data.pagination === false);
        toggleHidden(nextEl, data.pagination.nextPage === false);
      }

      if (data.pagination.currentPage === 0) {
        listEl.innerHTML = "";
      }

      for (let m = 0; m < data.items.length; m += 1) {
        const item = data.items[m];

        const liEl = document.createElement("div");
        liEl.innerHTML = templateEl.innerHTML;
        liEl.innerHTML = liEl.innerHTML.replace("{{NAME}}", item.name.fullName);
        liEl.innerHTML = liEl.innerHTML.replace("{{TITLE}}", item.title);
        if (item.nmlsNum) {
          liEl.innerHTML = liEl.innerHTML.replace("{{NMLS_NUM}}", `NMLS #${item.nmlsNum}`)
        } else {
          liEl.innerHTML = liEl.innerHTML.replace("{{NMLS_NUM}}", '');
        }
        if (item.region)  {
          liEl.innerHTML = liEl.innerHTML.replace("{{REGION}}", item.region)
        } else {
          liEl.innerHTML = liEl.innerHTML.replace("{{REGION}}", '')
        }
        liEl.innerHTML = liEl.innerHTML.replace(
          "{{PHONE}}",
          `<a href="tel:${item.phone}">${item.phone}</a>`
        );
        liEl.innerHTML = liEl.innerHTML.replace("{{NMLS_NUM}}", item.nmlsNum ? `NMLS #${item.nmlsNum}`: '');
        liEl.innerHTML = liEl.innerHTML.replace("{{REGION}}", item.region ?? '')
        liEl.innerHTML = liEl.innerHTML.replace("{{EMAIL}}", item.email);
        liEl.innerHTML = liEl.innerHTML.replace(
          "{{CONTACT}}",
          `Contact ${item.name.firstName}`
        );

        if (!item.description) {
          liEl.querySelector(".bankercard-bio").innerHTML = "";
        } else {
          liEl.innerHTML = liEl.innerHTML.replace("{{BIO}}", item.description);
        }

        const liLinkEl = liEl.querySelector(".bankercard-cta a[href]");
        const ctaEl = liEl.querySelector(".bankercard-cta a[data-name]");
        const imgEl = liEl.querySelector(".bankercard-img");

        liLinkEl.setAttribute("href", item.url);
        ctaEl.setAttribute("data-name", item.ctaID);
        imgEl.style.backgroundImage = `url(${item.image.url ?? '/wp-content/themes/snb/images/webster-monogram-grey.png'})`;
        liEl.classList.add("bankercard");
        listEl.appendChild(liEl);

        const launchModal = () => {
          try {
            const modal = createModal(
              item.name.fullName,
              item.title,
              item.phone,
              item.image.url,
              item.email
            );
            const existingModals =
              document.querySelectorAll(".banker-modal-el");
            if (existingModals != null && existingModals.length) {
              [].forEach.call(existingModals, (elem) => {
                elem.parentNode.removeChild(elem);
              });
            }
            basicmodal.launch(modal, { className: "bankercard-modal" });
          } catch (error) {
            console.log("wpro_debug__launchModalerror__object");
            console.log({ wpro_debug__launchModalerror__object: error });
          }
        };

        liEl
          .querySelector(".banker-cta")
          .addEventListener("click", launchModal);
      }
    };

    const fetchJSON = async (pageIndex, callbackFunct) => {
      const getBankers = await fetch(
        `/bankers.json?${getFilterSettings(pageIndex)}`
      );
      getBankers.json().then((data) => {
        callbackFunct(data);
      });
    };

    const getItems = (pageIndexArg) => {
      // window.scrollBy(0, -400);
      const pageIndex = Number.isInteger(pageIndexArg) ? pageIndexArg : "";
      fetchJSON(pageIndex, outputItems);

      // preload the next page
      setTimeout(() => {
        fetchJSON(pageIndex + 1, () => {});
      }, 2500);
    };

    const clickPagination = function (event) {
      const goToPageIndex = Number(event.target.value);
      getItems(goToPageIndex);
    };

    nextEl.addEventListener("click", clickPagination);

    document.addEventListener("DOMContentLoaded", () => {
      getItems(0);
    });
  }
};

export default bankerSearchNoFilter;
